import Insight from "../insightClass";
import React from "react";
import { insight33Media } from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight060 = new Insight(
  "22 August 2025",
  {
    pageTitle: "Global Offshore Wind Weekly",
    metaDescription: "WeBridge Insights, Global Offshore Wind Weekly",
    keyWords:
      "European Offshore Wind Market development, Global Offshore Wind Weekly",
  },
  {
    src: insight33Media[0],
    alt: "offshore wind turbine",
  },
  "Global Offshore Wind Weekly (2025-08-22)",
  "",
  `A 1 GW floating offshore wind project in Scotland has submitted its offshore consent application—a pivotal step that moves the scheme from concept to the formal approvals track. The application signals the project is aligning port capacity, fabrication yards, and grid landing points to support serial assembly and tow out of large floating platforms in deep water. `,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>Global Offshore Wind Weekly (2025-08-22)</h1>
    <h2></h2>
    <p className="article-date">22 August 2025</p>
    <br />
    <p>
      Welcome to this week's <i>WeBridge Insights</i>, where we provide you with
      the latest updates and key developments from the global offshore wind
      market.
    </p>
    <br />
    <br />
    <br />
    <p>
      At <b>WeBridge</b>, we deliver forward-thinking analysis and expert
      commentary to keep you informed in this fast-evolving industry. Here's our
      roundup of the top stories this week, complete with professional insights
      to help you stay ahead:
    </p>
    <h3>1. Scotland 1 GW Floating Project Files Offshore Consent</h3>
    <p>
      A 1 GW floating offshore wind project in Scotland has submitted its
      offshore consent application—a pivotal step that moves the scheme from
      concept to the formal approvals track. The application signals the project
      is aligning port capacity, fabrication yards, and grid landing points to
      support serial assembly and tow out of large floating platforms in deep
      water. While the precise build out sequence and contracting model are
      still to be disclosed, filing for consent typically precedes key supplier
      down selections (floaters, moorings, dynamic export cables) and an
      indicative installation window. The development also dovetails with
      Scotland’s recent acceleration of floating wind ready harbours and laydown
      areas, as well as UK wide CfD reforms (longer tenors, higher
      administrative caps for floating) that improve bankability. Major
      remaining variables include the pace of environmental determinations, the
      specification of offshore transmission nodes (including potential HVDC
      interfaces), and competition for scarce heavy lift assets in 2026–28. If
      approvals and offtake line up on schedule, the project can help anchor a
      more durable local supply chain around manufacturing, pre assembly, and
      life of field O&M.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>Floating wind sits on an onshore critical path. We advise locking in:</p>
    <ol>
      <li>
        A mother port with sufficient contiguous laydown and quayside uplift.
      </li>
      <li>
        Long lead packages for mooring/anchoring and dynamic cables under
        framework terms.
      </li>
      <li>
        A phased energisation plan with the grid operator to smooth cash flows.
      </li>
    </ol>
    <p>
      Early EPCI consortia formation can de-risk change orders, while batch
      procurement of tow-out tugs and SOVs can shave contingency. Treat grid
      access certainty (offshore and onshore) as a headline IRR variable, not a
      footnote.
    </p>
    <h3>
      2. British Steel Ships 2,000+ Tons for £350m Scottish HV Cable Plant
    </h3>
    <p>
      British Steel has delivered over 2,000 tons of steel for Sumitomo
      Electric’s £350 million high voltage cable factory at the Port of Nigg.
      According to the project team, structural engineers BHC have installed the
      steelwork as part of a major facility that will supply subsea cables for
      offshore wind farms and grid connections when it opens next year. The
      workscope spans metal decking, concrete topping, cladding, and application
      of intumescent coatings before shipment to site. Besides its immediate
      construction footprint, the factory is expected to create hundreds of jobs
      and materially expand the UK’s high end cable manufacturing base—long a
      bottleneck for large scale offshore build outs. With AR7/AR8 auction
      rounds and a growing queue of Scottish floating projects, local cable
      capacity can be a decisive schedule hedge, reducing logistics risk and
      exposure to transcontinental supply chains for XLPE export cables. The
      Nigg development also builds on broader port upgrade momentum across
      Scotland’s Cromarty Firth and Moray Firth, reinforcing a north east
      cluster for fabrication, marshalling, and long term service.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Cabling is the capex and schedule keel of offshore wind. A domestic plant
      at Nigg reduces shipping lead times and aligns with phased floating wind
      tow out from Scottish ports. Developers should explore multi project cable
      framework agreements and optionality for both HVAC and HVDC, plus contract
      clauses for copper/aluminium indexation. For government and lenders, tying
      CfD milestones to domestic cable delivery windows can lower systemic delay
      risk and support higher gearing.
    </p>
    <h3>
      3. France: Third and Final Turbine Assembled for EFGL Floating Pilot
    </h3>
    <p>
      France’s Éoliennes Flottantes du Golfe du Lion (EFGL) floating pilot has
      reached a milestone with the third and final 10 MW Vestas turbine now
      assembled at Port La Nouvelle and readied for installation ~10 miles off
      Leucate/Barcarès. The first turbine was installed last month on a
      WindFloat semi submersible platform from Principle Power, with the
      remaining two scheduled to follow quickly toward a late August completion.
      EFGL is developed by Ocean Winds and Banque des Territoires, who also co
      develop two 500 MW fixed bottom projects on France’s west coast—d’Yeu
      Noirmoutier and Dieppe Le Tréport—highlighting a multi basin strategy that
      blends demonstration and scale. The Port La Nouvelle workflow showcases
      France’s emerging capability to manage heavy lift assembly and wet storage
      for floating assets, while providing a template for serialisation in
      future AO9/AO10 floating tenders. From a system perspective, the pilot
      also tests dynamic cabling, mooring, and metocean resilience in the
      Mediterranean, generating learnings that should cut risk premia when
      France scales from pilots to commercial arrays.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      EFGL is more than a demo—it’s an industrial rehearsal. The near back to
      back assembly cadence at Port La Nouvelle validates laydown logistics and
      towing choreography essential for multi GW floating hubs. We’d expect
      rapid knowledge transfer into port design (craneage, quayside load
      bearing) and standardised interface specs (mooring fairleads, J tubes,
      cable hang offs). Developers bidding in France’s next floating rounds
      should budget for early port reservations and SOV/CTV capacity to avoid
      peak season congestion.
    </p>
    <h3>4. Global Vessels: Construction Market Could Nearly Double by 2030 </h3>
    <p>
      New research flagged by 4C Offshore suggests the offshore wind vessel
      construction market could grow from ~£6.8bn today to ~£12.5bn by 2030, a
      10.9% CAGR. The expansion is driven by larger next gen turbines (20 MW
      class emerging), deeper water installs, and higher volumes across Europe,
      APAC, and North America. Fleet needs span WTIVs, heavy lift vessels, CLVs,
      SOVs, and jack ups—kitted with dynamic positioning, larger cranes, motion
      compensated gangways, and specialised deck layouts. Typical 18–36 month
      build times, plus policies like the Jones Act in the US, are pushing
      earlier order placement and region specific designs. The report claims
      annual global offshore wind investment exceeds ~£44.5bn, with ~500 GW
      operational by 2050 in long term projections—implying sustained demand for
      installation and O&M tonnage if procurement keeps pace. For shipyards,
      that means clearer demand signals and opportunities in modular designs and
      multi role vessels that can pivot between turbines, foundations, and cable
      scopes.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Vessel scarcity is already pricing risk into EPC. We recommend developers
      bundle multi project time charter options and escalation caps into
      tendering, while shipowners seek convertible specs (e.g., crane upgrades,
      deck strengthening) to future proof assets for 20 MW turbines and floating
      operations. Europe’s yards can capture value if they standardise
      hull/platform families and exploit lifecycle revenues (refits, upgrades).
      Policymakers should synchronise auction timetables with yard capacity to
      avoid boom bust orderbooks.
    </p>
    <h3>
      5. United States: New IRS Guidance May Favour Offshore Wind Despite
      Politics
    </h3>
    <p>
      Despite headline political risk around the “One, Big, Beautiful Bill Act,”
      a new IRS guidance on “pre approved renewables” clarifies what counts as
      “beginning of construction” and recognises “excusable disruptions” (e.g.,
      severe weather, natural disasters, permitting delays). According to
      analysis cited by 4C Offshore, this nuance could benefit offshore wind,
      where large components and marine works often precede offshore
      installation. The guidance reportedly removes the 5% safe harbour
      fallback, but allows qualifying via significant physical work (e.g., off
      site manufacturing, on site foundation activity) initiated before a 2026
      deadline, while addressing the continuity safe harbour window. Market
      observers argue that—if applied consistently—this clarity can stabilise
      development timelines and support tax credit eligibility even as federal
      policy rhetoric remains volatile. In practice, developers may now harden
      schedules around physical work milestones, bolstered by documentation
      chains across OEM factories, yards, and ports.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Treat the guidance as a procedural playbook: pull forward documented
      physical work starts (foundations, towers, nacelles) and lock in supplier
      attestations. Structure contracts with adjustment clauses for inflation/FX
      and ensure EPCs can demonstrate meaningful pre 2026 progress. For
      financiers, diligence should focus on continuity evidence and cross
      referenced manufacturing logs. At state level, coupling BOEM milestones
      with transmission awards would further de risk bankability.
    </p>
    <h3>
      6. South Korea: DNV Secures Two Year Management Role on 400 MW Wando
      Jangbogo
    </h3>
    <p>
      DNV has won a two year management contract supporting Kolon Global
      Corporation’s Wando Jangbogo offshore wind farm (400 MW), providing
      turbine selection, tender preparation, bid evaluation, and contract
      negotiation. The developer consortium includes Kolon Global, Korea Western
      Power, and Jeonnam Development Corporation. DNV also plans a community
      participation model to improve local acceptance and long term co
      prosperity around Wando. Early management input aims to embed risk
      controls during optioneering and supplier selection—particularly valuable
      where typhoon exposure, seabed conditions, and grid integration add
      complexity. Although still in planning, the project is positioned to power
      hundreds of thousands of homes and build Korean developer capability as
      the country scales both fixed bottom and floating projects.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      Korea’s pipeline will demand bankable standardisation: common turbine
      ratings across phases, unified inter array voltages, and templates for
      marine warranty and logistics risk. We recommend a stage gate approach
      (concept &gt; pre FEED &gt; FEED &gt; FID) with independent validation at
      each gate to maintain financeability. Social licence is not a box
      tick—codify fisheries engagement and revenue sharing early to avoid late
      surprises. Finally, align early with KSOE/shipyard capacity for jacket,
      substation, and SOV builds to prevent bottlenecks.
    </p>
    <h3>
      7. Japan: ENEOS Partners with Shoreline Wind to Deploy AI for Project
      Delivery
    </h3>
    <p>
      Shoreline Wind (Norway) has partnered with ENEOS Renewable Energy (Japan)
      to deploy AI enabled lifecycle software aimed at improving construction
      planning, logistics, and O&M for Japanese offshore wind. The platform is
      designed to simulate weather windows, vessel utilisation, and supply chain
      constraints to surface cost/time trade offs and “hidden efficiencies” from
      early development through operations. ENEOS points to AI support across
      project scopes where Japan’s unique parameters—typhoon seasons, port
      constraints, long fetches—can complicate schedule certainty. The
      collaboration aligns with Japan’s policy trajectory: ~10 GW by 2030 and
      30–45 GW by 2040 targets under the 7th Strategic Energy Plan. If scaled,
      digital planning and continuous re optimisation could compress contingency
      and reduce the risk premia that have kept some Japanese projects on the
      sidelines.
    </p>
    <p>
      <b>WeBridge Insights:</b>
    </p>
    <p>
      AI is most valuable when paired with operational telemetry (SOV movements,
      crane hours, metocean feeds) and contract levers (liquidated damages,
      weather standby). We recommend developers require data sharing clauses
      with marine contractors and use AI outputs to drive “evergreen” method
      statements—updated monthly as weather, fleet, and port realities change.
      For lenders, AI backed schedule risk analyses can sharpen P90/P50
      narratives and inform contingency sizing.
    </p>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
